import axios from 'axios';
import { app } from '@/vendors/firebase/firebase';
import ShopInfoTransformer from './shopInfoTransformer';

export default {
  async list(shopId) {
    const res = [];
    const snapshot = await app.firestore()
      .collection('shops')
      .where('shopId', '==', shopId)
      .get();
    snapshot.forEach((doc) => {
      res.push(ShopInfoTransformer.transformOne(doc.data()));
    });
    return ShopInfoTransformer.transformList(res);
  },

  async putHistory(history) {
    await app.firestore()
      .collection('histories')
      .add(history);
  },

  async getShopAddrFromPOS(shopId) {
    const url = `${process.env.VUE_APP_SHOP_INFO_ENDPOINT}${shopId}?include=address`;

    const shopInfo = await axios.get(url)
      .catch((error) => {
        console.log(error);
        return '';
      });
    return shopInfo
      ? ShopInfoTransformer.getAddrString(shopInfo.point_of_sale.address) : '';
  },
};
